import { render, staticRenderFns } from "./ServerOutboundTable.vue?vue&type=template&id=89fc4504&scoped=true"
import script from "./ServerOutboundTable.vue?vue&type=script&lang=js"
export * from "./ServerOutboundTable.vue?vue&type=script&lang=js"
import style0 from "./ServerOutboundTable.vue?vue&type=style&index=0&id=89fc4504&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89fc4504",
  null
  
)

export default component.exports